/**
 * API path for sending user interaction data to telemetry for analytics
 * @type {string}
 * Method: POST
 */
export const TELEMETRY_API = 'https://api.telemetry.analogtools.io/v1/logs';
